import React from 'react'
import { TextField } from '@mui/material'
import { DateTimePicker } from '@mui/x-date-pickers'
import { Moment } from 'moment'
import * as R from 'ramda'

import { Field, Nil } from '../../../types'
import PuiInput from '../PuiInput'

export interface DateTimeCalendarProps {
  readonly disabled?: boolean
  readonly field?: Field
  readonly label?: string
  readonly onChange: (date: string | Nil) => void
  readonly value?: string | Moment
}

export function DateTimeCalendar({
  disabled = false,
  field,
  label,
  onChange,
  value,
}: DateTimeCalendarProps) {
  return (
    <DateTimePicker
      PopperProps={{
        sx: {
          '.MuiPickersCalendarHeader-root': {
            '.MuiPickersArrowSwitcher-button': {
              '&:first-of-type': {
                position: 'absolute',
                left: 4,
                top: 14,
              },
              '&:last-of-type': {
                position: 'absolute',
                right: 4,
                top: 14,
              },
            },
          },
        },
      }}
      disabled={disabled}
      label={label}
      renderInput={({ InputProps, InputLabelProps, ...rest }) => {
        const endAdornment = InputProps?.endAdornment as React.ReactElement
        return (
          <PuiInput field={field}>
            <TextField
              InputLabelProps={{
                ...InputLabelProps,
                shrink: field?.value || value ? true : undefined,
              }}
              InputProps={R.omit(['endAdornment'], InputProps)}
              onClick={endAdornment?.props?.children?.props?.onClick}
              {...rest}
              error={!field?.valid}
            />
          </PuiInput>
        )
      }}
      value={field?.value ?? value}
      views={['day', 'hours', 'minutes']}
      onChange={onChange}
    />
  )
}
